document.addEventListener('DOMContentLoaded', function() {
	var heroImages = [].slice.call(document.querySelectorAll('#hero .bg-container, section.circle_video .video-element')),
		lazyImages = [].slice.call(document.querySelectorAll('main img:not(.not-lazy), main .bg-container:not(.not-lazy), footer img')),
		active = false,
		heroLazyLoad = function() {
			heroImages.forEach(function(img) {
				imgLazyLoad(img, 300);

				heroImages = heroImages.filter(function(image) {
					return image !== img;
				});

				if(heroImages.length === 0) {
					document.removeEventListener('scroll', heroLazyLoad);
					window.removeEventListener('resize', heroLazyLoad);
					window.removeEventListener('orientationchange', heroLazyLoad);
				}
			});
		};

	// Hero Images
	setTimeout(heroLazyLoad, 1);

	// Regular Images
	var lazyLoad = function() {
		if(active === false) {
			active = true;

			setTimeout(function() {
				lazyImages.forEach(function(img) {
					if((img.getBoundingClientRect().top <= (window.innerHeight + 300) && img.getBoundingClientRect().bottom >= 0) && getComputedStyle(img).display !== 'none') {
						imgLazyLoad(img, (img.classList.contains('bg-container') ? 300 : 0));

						lazyImages = lazyImages.filter(function(image) {
							return image !== img;
						});

						if(lazyImages.length === 0) {
							document.removeEventListener('scroll', lazyLoad);
							window.removeEventListener('resize', lazyLoad);
							window.removeEventListener('orientationchange', lazyLoad);
						}
					}
				});

				active = false;
			}, 200);
		}
	};

	document.addEventListener('scroll', lazyLoad);
	window.addEventListener('resize', heroLazyLoad);
	window.addEventListener('resize', lazyLoad);
	window.addEventListener('orientationchange', heroLazyLoad);
	window.addEventListener('orientationchange', lazyLoad);
});

function imgLazyLoad(img, delay) {
	var url = img.getAttribute('data-src'+(checkWidth(768) && img.hasAttribute('data-src-mobile') ? '-mobile' : ''));

	if(img.tagName == 'IMG' || img.tagName == 'VIDEO' || img.tagName == 'IFRAME')
		img.src = url;
	else
		img.style.backgroundImage = 'url('+url+')';

	setTimeout(function() {
		img.classList.add('loaded');
	}, delay);
}